/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { Component, OnDestroy, OnInit } from "@angular/core";
import { MatToolbarModule } from "@angular/material/toolbar";
import { Subject, takeUntil, tap } from "rxjs";
import { AppStateService } from "../../services/state/app-state.service";
import { UserStateService } from "../../services/state/user-state.service";
import { ButtonComponent } from "../button/button.component";
import { PopoverFloatingComponent } from "../popover/popover.component";
import { ProfileComponent } from "../profile/profile.component";
import { ToggleComponent } from "../toggle/toggle.component";
import { UsersService } from "./../../services/users.service";

@Component({
	selector: "globalictcc-header",
	standalone: true,
	imports: [
		MatToolbarModule,
		ButtonComponent,
		ProfileComponent,
		PopoverFloatingComponent,
		ToggleComponent
	],
	templateUrl: "./header.component.html",
	styleUrl: "./header.component.scss"
})
export class HeaderComponent implements OnInit, OnDestroy {
	public hasUnreadNotifications: boolean = true;
	public username: string = "";
	public role: string = "";
	public isAppAccessible: boolean = false;

	private _destroy$ = new Subject<void>();

	constructor(
		private _userStateService: UserStateService,
		private _appStateService: AppStateService,
		private _usersService: UsersService
	) {}

	ngOnInit() {
		this._userStateService.userInfo$
			.pipe(
				tap({
					next: userInfo => {
						this.username = `${userInfo.name} ${userInfo.surname}`;
						this.role = userInfo.role;
					}
				}),
				takeUntil(this._destroy$)
			)
			.subscribe();

		this._appStateService.isAppAccessible$
			.pipe(
				tap({
					next: isAccessible => {
						this.isAppAccessible = isAccessible;
					}
				}),
				takeUntil(this._destroy$)
			)
			.subscribe();
	}

	ngOnDestroy() {
		this._destroy$.next();
		this._destroy$.complete();
	}

	/**
	 * Toggles the accessibility mode of the application.
	 *
	 * @param isAccessible - A boolean indicating whether the application should be in accessible mode.
	 */
	public onToggleAccessibility(isAccessible: boolean) {
		this._appStateService.setIsAppAccessible(isAccessible);
	}

	/**
	 * Handles the user logout process.
	 *
	 * Calls the gateway logout endpoint and then performs a full browser navigation
	 * to the returned identity provider logout URL (avoids CORS issues of following a 302 via XHR).
	 */
	public onLogout() {
		this._usersService
			.logout()
			.pipe(tap({ next: ({ logoutUrl }) => window.location.assign(logoutUrl) }))
			.subscribe();
	}
}
